export default function () {
    return {
        view: 'grid',
        mediaQuery: null,

        init() {
            // media query для md
            this.mediaQuery = window.matchMedia('(min-width: 768px)');

            // первичная установка
            this.applyView();

            // слушаем изменение размера
            this.mediaQuery.addEventListener('change', () => {
                this.applyView();
            });
        },

        applyView() {
            // если мобильный — только grid
            if (!this.mediaQuery.matches) {
                this.view = 'grid';
                return;
            }

            // desktop — берём сохранённое
            const saved = localStorage.getItem('catalog_view');
            this.view = saved ? saved : 'grid';
        },

        setView(type) {
            // запрещаем list на мобиле
            if (!this.mediaQuery.matches && type === 'list') {
                return;
            }

            this.view = type;
            localStorage.setItem('catalog_view', type);
        }
    };
}
